import EventEmitter from "../utils/EventEmitter";
import SelectSimple from "./SelectSimple";

export default class viewFiltersForm extends EventEmitter {
    constructor(element) {
        super();

        // Elements
        this.el = element
        this.form = this.el.querySelector('form')

        // Store / Data
        this.selects = []

        this.initSelects()
    }

    initSelects() {
        this.selectsSimple = document.querySelectorAll('.js-form-type-select')

        this.selectsSimple.forEach((el) => {
            const select = new SelectSimple(el)
            select.on('selectHasChanged', () => {
                this.submit()
            })
            this.selects.push(select)
        })
    }

    destroy() {
        // remove and destroy all selects instances
        this.selects.forEach((select) => {
            select.off('selectHasChanged')
            select.destroy()
        })
    }

    submit() {
        this.el.querySelector('input[type="submit"]').dispatchEvent(new Event('click'))
    }
}
